import Chip from "@mui/material/Chip";

const APChip = ({
  text,
  color = "primary",
  captialiseText = false,
}: {
  text: string;
  color:
    | "primary"
    | "secondary"
    | "tertiaryGreen"
    | "tertiaryBlue"
    | "tertiaryDarkBlue"
    | "success"
    | "error"
    | "outline"
    | "info";
  captialiseText?: boolean;
}) => {
  const labelText = captialiseText ? text.toUpperCase() : text;
  return (
    <Chip color={color} label={labelText} size="small" variant="outlined" />
  );
};

export default APChip;
